import DashBoardHeader from '../../header_dashboard/dashboard_header';
import ProfileNavBar from '../profile_navbar/profile_navbar';
import validate from '../../util/validate';
import {toTitleCase, join} from '../../util/common';
import ShowError from '../../components/error/show_error';
import authActions from '../../auth/auth_actions';
import profileActions from '../../profile/profile_actions';
import LogoutPopUp from '../../components/logoutPopUp/logout_pop_up';
import CONSTANTS from '../../common_constants';
import React from 'react';
import {Link, browserHistory} from 'react-router';
import {routerActions} from 'react-router-redux';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import MediaQuery from 'react-responsive';
import LoggedinFooter from '../../footer/loggedin_footer';
import cookies from '../../util/cookie';
import SuccessMessage from '../../components/success/success_msg';
import './account_payment.less';
import '../../payment/payment.less'
import paymentActions from '../../payment/payment_actions';
import NumberFormat from 'react-number-format';
import $ from 'jquery';
import InputComponent from '../../components/input_component/input_component';
import RadioButton from '../../components/radio_button/radio_button';
import ConfirmDeleteComponent from '../../components/confirm_box/confirm_box';


class Card extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      cardTokenId: props.card.cardTokenId
    }
  }
  getSelectBoxValue = (selectedCardId) => {
    this.setState({"cardTokenId": selectedCardId});
    this.props.updatedSelectedCardId(selectedCardId);
  }

  render(){
    const {props} = this;
    const {card} = this.props;
    const {cardBrand,lastFourDigit,cardHolderName,cardExpMonth,cardExpYear,isDefault,cardTokenId} = card;
    const self = this;
    let radioName = cardBrand+" - "+lastFourDigit;
    const expiry = cardExpMonth + "/" + cardExpYear;
    let radioButtonName = 'card-select';
    let index = props.cardIndex;
    let CheckBoxLabelText = radioName;
    const defaultCardSel = isDefault ? isDefault : false;
    return(
      <div className = "credit-card">
        <div className = "credit-card-data-wrap card-number">
          <div className="radio-button-wrap">
            <div className="radio-button" key={index}>
              {radioName}
            </div>
          </div>
        </div>
        <div className = "credit-card-data-wrap card-holder-name-wrap">
          <div className = "credit-card-data">{cardHolderName}</div>
        </div>
        <div className = "credit-card-data-wrap expiry-wrap">
          <div className = "credit-card-data">{expiry}</div>
        </div>
        <div className = "credit-card-data-wrap card-holder-name-wrap">
          {
              defaultCardSel && <div className = "credit-card-data default-card-section">DEFAULT</div>
          }
          {
              !defaultCardSel && <div onClick = {this.props.updateCard}className = "credit-card-data make-default-card-section">MAKE DEFAULT</div>
          }
        </div>
        <div className = "credit-card-data-wrap card-holder-name-wrap">
          <div className = "credit-card-data"><span onClick = {this.props.deleteCard}className="icon-bin remove-card"></span></div>
        </div>
      </div>
    )
  }
}
class StripePaymentForm extends React.Component{
    constructor(props){
      super(props);
      this.state = {
        cardNumber: '',
        cvv: '',
        expiry: '',
        cardHolderName: '',
        isAgree: false,
        showPaymentWidget: props.showPaymentWidget,
        showConfirmBox : false
      }
      this.changeHandler = this.changeHandler.bind(this);
    }

    addNewPayment = (e) => {
      e.preventDefault();
      this.setState({showPaymentWidget: !this.state.showPaymentWidget});
      this.props.setShowPaymentWidget();
      this.clearAllFields();
    }
    clearAllFields = () =>{
      this.setState({
        cardNumber: '',
        cvv: '',
        expiry: '',
        cardHolderName: '',
        isAgree: false
      })
    }
    formatExpiryChange = (val) => {
      if(val && Number(val[0]) > 1){
        val = '0'+val;
      }
      if(val && val.length >1 && Number(val[0]+val[1]) > 12){
        val = '12'+val.substring(2,val.length);
      }
      val = val.substring(0,2)+ (val.length > 2 ? '/'+val.substring(2,4) : '');
      return val;
    }

    changeHandler = (type,e) => {
      let inputVal = e.target.value;
      const stateObj = {};
      if(type==="cvv" && inputVal.length>4) return false;

      stateObj[type] = inputVal;
      this.setState(stateObj);
    }

    getSelectBoxValue = (selectBoxVal) => {
      if(selectBoxVal && selectBoxVal.length>0) this.setState({isAgree: true});
    }

    saveCardData = (e) => {
      e.preventDefault();

      const {state,props} = this;
      const {cardNumber,cvv,expiry,cardHolderName} = state;
      const expiryString = expiry.split("/");
      const expiryMonth = expiryString[0];
      const expiryYear = expiryString[1];

      const cardData = {
        number: cardNumber,
        cvc: cvv,
        exp_month: expiryMonth,
        exp_year: expiryYear,
        name: cardHolderName
      }

      props.createToken(cardData,state.isAgree);
    }

    componentWillReceiveProps(newProps){
        if (newProps.payment) this.setState({showPaymentWidget: newProps.showPaymentWidget})
    }
    back = () =>{
      this.setState({showPaymentWidget: !this.state.showPaymentWidget});
      this.props.setShowPaymentWidget();
    }
    confirmDeleteCard = (card ,index) =>{
      this.setState({
        showConfirmBox : true,
        deleteCardDetails : card,
        deleteCardIndex :index
      })
    }
    deleteCard = () =>{
      let cardId = this.state.deleteCardDetails.cardTokenId;
      let cardIndex = this.state.deleteCardIndex
      this.setState({isLoading: true})
      this.props.paymentActions.removeCard(cardId , cardIndex).then((data) => {
        this.setState({isLoading: false})
      }, (errorRes) => {
        this.setState({
          isLoading: false,
          error: errorRes.error
        }, $("html, body").animate({scrollTop: 0}, 1000));
      });
    }
    updateCard = (card) =>{
      this.setState({isLoading: true})
      let cardDetails = Object.assign({}, card);
      cardDetails.cardId = cardDetails.cardTokenId;
      cardDetails.makeCardDefault = true;
      delete cardDetails["cardTokenId"]
      this.props.paymentActions.updateDefaultCard(cardDetails).then((data) => {
        this.setState({isLoading: false})
      }, (errorRes) => {
        this.setState({
          isLoading: false,
          error: errorRes.error
        }, $("html, body").animate({scrollTop: 0}, 1000));
      });
    }
    hideConfirmBox = () =>{
      this.setState({
        showConfirmBox : false
      })
    }
    render(){
      const {state,props} = this;
      let radioButtonNameArray = ['I verify that my shipment meets all the applicable legal requirements.'];
      let radioButtonName = 'confirm-agreement';

      const self = this;
      return(
        <div className="payment-section-wrap">
          <ConfirmDeleteComponent onConfirmCallback = {this.deleteCard} closePopupCallback = {this.hideConfirmBox}header = "Confirm" description = "Are you sure that you want to delete the card?" popupState = {this.state.showConfirmBox}/>
          {state.isLoading && <div className = "loader-wrapper"><div className = "loader"></div></div>}
          {state.error && <ShowError errorMessage={state.error}/>}
          <form className="payment">
            <div className="payment-header">Payment</div>
            {
              props.payment.cards && props.payment.cards.length>0 && !state.showPaymentWidget &&
              <div className = "card-holder-wrap">
               <div className="card-holder-header">Payment Method</div>
                {
                  (props.payment.cards || []).map((card,key) => {
                    return(
                      <Card card={card} updateCard = {() =>self.updateCard(card)}key={key} deleteCard = {() => self.confirmDeleteCard(card, key)} cardIndex={key} updatedSelectedCardId={self.props.updatedSelectedCardId}/>
                    )
                  })
                }
              </div>
            }
            {
              props.payment.cards && props.payment.cards.length ==0 && !state.showPaymentWidget &&
              <div className = "card-holder-header">
                You don't have any cards saved.
              </div>
            }
            {
              state.showPaymentWidget && <div className="back-section" onClick = {this.back}>
                          <span className="icon-icn_back"></span>
                          <span className = "back-content">Back</span>
                      </div>
            }
            {
              state.showPaymentWidget &&
              <div className = "payment-form-widget">
                <div className = "input-component-wrap">
                  <div className = "title">{"Card Number"}</div>
                  <div className = "input-component">
                    <NumberFormat
                      format="#### #### #### ####"
                      onChange ={this.changeHandler.bind(self,"cardNumber")}
                      value = {state.cardNumber}
                      className ="input"
                      placeholder = "Card number"/>
                  </div>
                </div>
                <div className = "input-component-wrap">
                  <div className = "title">Expiration</div>
                  <div className = "input-component">
                    <NumberFormat
                      format={this.formatExpiryChange}
                      onChange ={this.changeHandler.bind(self,"expiry")}
                      value = {state.expiry}
                      className ="input"
                      placeholder = "MM/YY"/>
                  </div>
                </div>
                <div className = "input-component-wrap">
                  <div className = "title">Security Code</div>
                  <div className = "input-component">
                    <input type="number" name = "cvv" onChange ={this.changeHandler.bind(self,"cvv")} value = {state.cvv} className ="input" placeholder = "CVV" maxLength="4"/>
                  </div>
                </div>
                <div className = "input-component-wrap">
                  <div className = "title">Card holder's name</div>
                  <div className = "input-component">
                    <input type="text"
                           name = "cardHolderName"
                           onChange ={this.changeHandler.bind(self,"cardHolderName")}
                           value = {state.cardHolderName}
                           className ="input"
                           placeholder = "Card holder's name"/>
                  </div>
                </div>
                <div id="paymentTerms">If you decide to cancel your shipment after a carrier has accepted it, you will be charged 5% of the package's value. After carrier has taken your package cancellation is not allowed.</div>
                <RadioButton radioButtonName = {radioButtonName} radioButtonNameArray={radioButtonNameArray} getValueCallback = {this.getSelectBoxValue} />
                <button className="btn orange confirm-btn" onClick = {this.saveCardData}>Submit Card</button>
              </div>
            }
            {
              !state.showPaymentWidget &&
              <button className="btn green" id="confirmBtn" onClick = {this.addNewPayment}>{"Add new payment method"}</button>
            }
          </form>
        </div>
      )
    }
}

class AccountPaymentDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error:'',
      isLoading: false,
      disableSaveBtn: false,
      isLoading: false,
      payment: props.payment,
      defaultCardId : null,
      showPaymentWidget: false
    }
    this.logout = this.logout.bind(this);
  }

  logout() {
    this.props.authActions.logout().always(() => {
        cookies.delete('_sd');
        document.location.href = '/';
    });
  }
  setShowPaymentWidget = () => {
    this.setState({showPaymentWidget: !this.state.showPaymentWidget})
  }
  getAllCards = () => {
    const self = this;
    const {paymentActions} = this.props;
    this.setState({isLoading: true});
    paymentActions.getAllCards().then(() => {
      this.setState({isLoading: false});
      if(self.props.payment.cards.length > 0) {
        this.getDefaultCardId();
      }
      else if(self.props.payment.cards.length===0){
        this.setState({showPaymentWidget: true});
      }
    }, (errorRes) => {
      this.setState({
        isLoading: false,
        error: errorRes.error
      }, $("html, body").animate({scrollTop: 0}, 1000));
    });
  }

  getDefaultCardId = () => {
    const {cards} = this.state.payment;
    let defaultCardId = cards.filter((card,key) => {
      return card.isDefault===true;
    });
    if(defaultCardId && defaultCardId.length>0){
      this.setState({defaultCardId: defaultCardId[0].cardTokenId});
    }
  }

  componentDidMount() {
    Stripe.setPublishableKey(CONSTANTS.STRIPE_KEY);
    this.getAllCards();
  }

  componentWillReceiveProps(newProps){
    if (newProps.payment) this.setState({payment: newProps.payment});
  }

  addCard = (token) => {
    const {paymentActions} = this.props;
    let paramObj = {"stripeToken": token,"makeCardDefault":false};
      this.setState({"isLoading": true});
    paymentActions.addCard(paramObj).then((paramObj) => {
      this.setState({"showPaymentWidget": false});
      this.getAllCards();
    }, (errorRes) => {
      this.setState({
        isLoading: false,
        error: errorRes.error
      }, $("html, body").animate({scrollTop: 0}, 1000));
    });
  }

  createToken = (cardData,isAgree) => {
    this.setState({
      error : ""
    })
    const self = this;
    if(!Stripe.card.validateCardNumber(cardData.number)){
      $("html, body").animate({scrollTop: 0}, 1000);
      return this.setState({"error": "Please enter a valid card number."},  $("html, body").animate({scrollTop: 0}, 1000));
    }
    if(!Stripe.card.validateExpiry(cardData.exp_month,cardData.exp_year)){
      $("html, body").animate({scrollTop: 0}, 1000);
      return this.setState({"error": "Please enter aTesla valid expiration date."},  $("html, body").animate({scrollTop: 0}, 1000));
    }
    if(!Stripe.card.validateCVC(cardData.cvc)){
      $("html, body").animate({scrollTop: 0}, 1000);
      return this.setState({"error": "Please enter a valid CVC code."},  $("html, body").animate({scrollTop: 0}, 1000));
    }
    if(!cardData.name && cardData.name.length===0) return this.setState({"error": "Please enter a valid card holder's name."},  $("html, body").animate({scrollTop: 0}, 1000));
    if(!isAgree) return this.setState({"error": "Please agree to the shipment legal requirements."}, $("html, body").animate({scrollTop: 0}, 1000));

    this.setState({"disableSaveBtn": true , isLoading : true});

    Stripe.card.createToken(cardData, (responseCode, response) => {
      if(responseCode!==200){
        this.setState({"error": response.error.message ,isLoading : false}, $("html, body").animate({scrollTop: 0}, 1000));
      }
      else{
        const token = response.id;
        this.addCard(token);
        this.setState({
          error : ""
        })
      }
    });
  }
  updatedSelectedCardId = (defaultCardId) => {
    this.setState({defaultCardId})
    let state = Object.assign({},this.state)
    state.payment.cards.map((card, index)=>{
      if(card.cardTokenId == defaultCardId)
        card.isDefault = true
      else
        card.isDefault = false
    })
    this.setState({
      payment : state.payment
    })
  }
  render() {
    const {props, state} = this;
    const {self} = this;
    return (
      <div className = "account-payment-details-wrap">
        {state.isLoading && <div className = "loader-wrapper"><div className = "loader"></div></div>}
        {state.error && <ShowError errorMessage={state.error}/>}
        <StripePaymentForm
          payment={state.payment || {}}
          createToken = {this.createToken}
          disableSaveBtn={state.disableSaveBtn}
          updatedSelectedCardId = {this.updatedSelectedCardId}
          showPaymentWidget = {state.showPaymentWidget}
          setShowPaymentWidget = {this.setShowPaymentWidget}
          paymentActions = {this.props.paymentActions}
          authActions = {this.props.authActions}
        />
      </div>
    )
  }
}

class AccountPayment extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {props, state} = this;
    const {userData} = props.authState;
    let sessionValid = true ;
    if("sessionValid" in props.authState.userData) sessionValid = props.authState.userData.sessionValid

    let user = {
        name: '',
        imageUrl: '',
        isVerified: '',
        creditAmount: ''
     };

    if(props.authState) {
      user.name = userData.name;
      user.imageUrl = userData.profileImageUrl;
      user.isVerified = userData.isVerified;
      user.creditAmount = userData.creditAmount
    }
    return (
      <div className="account-details-wrap account-section">
        <DashBoardHeader user={user} logout={this.logout}/>
        <LogoutPopUp isOpen={!sessionValid}></LogoutPopUp>
        <div className="account-header-wrap">
          <div className="wrapper">
            <h2 className="page-header account-page-header">Account</h2>
          </div>
        </div>
        <div className="wrapper account-wrapper">
          <div className="profile-nav-bar-component">
            <ProfileNavBar pathname={this.props.location.pathname} userData={user}/>
            </div>
            <div className="account-details-component">
              <AccountPaymentDetails payment = {this.props.payment}paymentActions = {this.props.paymentActions}authActions ={props.authActions} userData={props.authState.userData} profileActions={props.profileActions}/>
            </div>
          </div>
          <LoggedinFooter />
      </div>
    )
  }
}

AccountPayment = connect((state) => {
    return {
        authState: state.app.auth,
        profile: state.app.profile,
        payment: state.app.payment,}
}, (dispatch) => {
    return {
        routerActions: bindActionCreators(routerActions, dispatch),
        authActions: bindActionCreators(authActions, dispatch),
        paymentActions : bindActionCreators(paymentActions, dispatch),
        profileActions: bindActionCreators(profileActions, dispatch)
    }
})(AccountPayment);

export default AccountPayment;



// WEBPACK FOOTER //
// app/profile/account_payment/account_payment.jsx